export const replacePlaceholderValues = (
  originalString: string,
  valueToReplace: string,
  newValue: string
) => {
  if (!originalString) return "";
  if (!originalString.includes(valueToReplace) || valueToReplace === "")
    return originalString;
  return originalString.replaceAll(valueToReplace, newValue);
};
